export function formatApiErrorDetail(detail: unknown): string | null {
  if (!detail) return null;
  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (!item || typeof item !== 'object') return String(item);

        const errorItem = item as { loc?: unknown[]; msg?: unknown; message?: unknown };
        const location = Array.isArray(errorItem.loc)
          ? errorItem.loc.filter((part) => part !== 'body').join('.')
          : '';
        const messageText = String(errorItem.msg || errorItem.message || JSON.stringify(item));

        return location ? `${location}: ${messageText}` : messageText;
      })
      .join('; ');
  }

  if (typeof detail === 'object') {
    const errorObject = detail as { msg?: unknown; message?: unknown; detail?: unknown };
    if (typeof errorObject.msg === 'string') return errorObject.msg;
    if (typeof errorObject.message === 'string') return errorObject.message;
    if (typeof errorObject.detail === 'string') return errorObject.detail;
    return JSON.stringify(detail);
  }

  return String(detail);
}

/**
 * Машинный код ошибки из структурированного detail вида { code, message }.
 * Если detail — строка или список (старый формат) либо кода нет, возвращает null.
 */
export function getApiErrorCode(error: unknown): string | null {
  const detail = (error as { response?: { data?: { detail?: unknown } } } | null | undefined)
    ?.response?.data?.detail;
  if (!detail || typeof detail !== 'object' || Array.isArray(detail)) return null;

  const { code } = detail as { code?: unknown };
  return typeof code === 'string' && code !== '' ? code : null;
}

export function getApiErrorMessage(error: any, fallback: string): string {
  const data = error?.response?.data;
  const detail = formatApiErrorDetail(data?.detail);
  const isHtml = (value: string | null) => Boolean(value && /<!doctype\s+html\b|<\/?[a-z][\w:-]*(?:\s[^<>]*)?\/?>/i.test(value));

  if (detail && !isHtml(detail)) return detail;
  if (error?.response?.status === 413) {
    return 'Сервер отклонил загрузку: файл превышает допустимый размер.';
  }

  const responseMessage = formatApiErrorDetail(data);
  if (responseMessage && !isHtml(responseMessage)) return responseMessage;
  if (isHtml(detail) || isHtml(responseMessage)) return fallback;
  return (typeof error?.message === 'string' ? error.message : null) || fallback;
}
